import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { AppInfoService } from '../../services/appInfo/app-info.service';

import { AppInfo } from '../app-info';

@Component({
  selector: 'app-info',
  templateUrl: './app-info.component.html',
  styleUrls: ['./app-info.component.css']
})
export class AppInfoComponent implements OnInit {
  @Input() app:AppInfo;
  editing:Boolean = false;
  originalAppInfo:AppInfo;

  @Output() notify: EventEmitter<string> = new EventEmitter<string>();

  constructor(protected appInfoService:AppInfoService) {}

  ngOnInit() {}

  edit() {
    this.originalAppInfo = new AppInfo(this.app);
    this.editing = true;
  }

  save() {
    this.appInfoService.update(this.app).then(_ => {
      this.editing = false;
    });
  }

  cancel() {
    this.app = this.originalAppInfo;
    this.editing = false;
  }

  delete() {
    this.appInfoService.delete(this.app).then(_ => {
      this.editing = false;
      this.notify.emit('deleted');
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/appsInfo/app-info/app-info.component.ts